


export default function GetBrowserLocale(): string {
  return navigator.languages && navigator.languages.length
          ? navigator.languages[0]
          : navigator.language;    
}
